import CardDesignerCardElementPlaceholder from './CardDesignerCardElementPlaceholder';

export default CardDesignerCardElementPlaceholder;
